import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d9b0e98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page new-game" }
const _hoisted_2 = {
  key: 0,
  class: "step"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rules" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Watsdat"),
  /*#__PURE__*/_createElementVNode("p", null, "Try to guess what you are looking at 👀")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Pick a category", -1))
const _hoisted_5 = { class: "category" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Most Popular", -1))
const _hoisted_7 = { class: "container" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "game-mode-content" }
const _hoisted_10 = { class: "game-mode-title" }
const _hoisted_11 = { class: "game-mode-description" }
const _hoisted_12 = { class: "category" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "By Release Date", -1))
const _hoisted_14 = { class: "container" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "game-mode-content" }
const _hoisted_17 = { class: "game-mode-title" }
const _hoisted_18 = { class: "game-mode-description" }
const _hoisted_19 = { class: "category" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "By Genre", -1))
const _hoisted_21 = { class: "container" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "game-mode-content" }
const _hoisted_24 = { class: "game-mode-title" }
const _hoisted_25 = { class: "game-mode-description" }
const _hoisted_26 = { class: "category" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "By Theme", -1))
const _hoisted_28 = { class: "container" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "game-mode-content" }
const _hoisted_31 = { class: "game-mode-title" }
const _hoisted_32 = { class: "game-mode-description" }
const _hoisted_33 = { class: "category" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "By Brand", -1))
const _hoisted_35 = { class: "container" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "game-mode-content" }
const _hoisted_38 = { class: "game-mode-title" }
const _hoisted_39 = { class: "game-mode-description" }
const _hoisted_40 = {
  key: 1,
  class: "step game-panel"
}
const _hoisted_41 = { class: "game-browser" }
const _hoisted_42 = { class: "games" }
const _hoisted_43 = { class: "game-name" }
const _hoisted_44 = { class: "game-details" }
const _hoisted_45 = {
  class: "game-data",
  title: "Players"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "person", -1))
const _hoisted_47 = {
  class: "game-data",
  title: "Rounds"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "sync", -1))
const _hoisted_49 = {
  key: 0,
  class: "game-settings"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Game", -1))
const _hoisted_51 = { class: "field" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Username", -1))
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "actions" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 1,
  class: "game-settings"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Game", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game-mode-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "game-mode-title" }, "Multiplayer"),
  /*#__PURE__*/_createElementVNode("div", { class: "game-mode-description" }, "Play with your friends or complete strangers!")
], -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game-mode-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "game-mode-title" }, "Challenge"),
  /*#__PURE__*/_createElementVNode("div", { class: "game-mode-description" }, "Guess as many answers as possible within 3 minutes!")
], -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = {
  key: 2,
  class: "game-settings"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Game", -1))
const _hoisted_64 = { class: "field" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1))
const _hoisted_66 = ["disabled"]
const _hoisted_67 = { class: "field" }
const _hoisted_68 = {
  class: "inline",
  for: "mode"
}
const _hoisted_69 = { class: "game-mode-content" }
const _hoisted_70 = { class: "game-mode-title" }
const _hoisted_71 = { class: "game-mode-description" }
const _hoisted_72 = { class: "field" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rounds" }, "Number of rounds", -1))
const _hoisted_74 = { class: "input-range" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { class: "field" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "duration" }, "Round duration", -1))
const _hoisted_78 = { class: "input-range" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = { class: "field" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "attempts" }, "Number of attempts", -1))
const _hoisted_82 = { class: "input-range" }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = { class: "field inline" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "public" }, "Public game", -1))
const _hoisted_86 = { class: "actions" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = ["disabled"]
const _hoisted_89 = { class: "actions" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["disabled"]

import { client } from '@/api';
import { Game, GameMode, GameStatus, GameType } from '@/api/types';
import { StoreParams } from '@/store/types';
import { onBeforeUnmount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ToggleButton from '../components/ToggleButton.vue';
import { collection, limit, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '@/firebase';

interface GameModeOption {
  mode: GameMode;
  title: string;
  description: string;
  color: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewGameView',
  setup(__props) {

const store = useStore<StoreParams>();
const router = useRouter();
const userModel = ref({ name: '' });
const gameModel = ref<{ mode: any, name: string, type: GameType | null, rounds: number, duration: number, attempts: number, public: boolean }>({
  mode: null,
  name: `${store.state.user?.name}'s game`,
  type: null,
  rounds: 20,
  duration: 30,
  attempts: 0,
  public: true,
});
const gameModes = ref({
  popular: [
    { mode: GameMode.Standard, title: 'Most popular of all time', description: 'The top games from all eras and platforms.', color: 'var(--blue-600)' },
  ],
  release: [
    { mode: GameMode['80s'], title: '80s', description: 'Popular games from the 80s', color: 'var(--orange-600)' },
    { mode: GameMode['90s'], title: '90s', description: 'Popular games from the 90s', color: 'var(--indigo-600)' },
    { mode: GameMode['2000s'], title: '2000s', description: 'Popular games from the 2000s', color: 'var(--purple-600)' },
    { mode: GameMode['2010s'], title: '2010s', description: 'Popular games from the 2010s', color: 'var(--red-600)' },
  ],
  genre: [
    { mode: GameMode.Action, title: 'Action', description: 'The most popular action games of all time', color: 'var(--cyan-500)' },
    { mode: GameMode.Adventure, title: 'Adventure', description: 'The most popular adventure games of all time', color: 'var(--green-500)' },
    { mode: GameMode.Indie, title: 'Indie', description: 'The most popular games made by indie developers', color: 'var(--red-400)' },
    { mode: GameMode.Music, title: 'Music', description: 'The most popular music games of all time', color: 'var(--pink-500)' },
    { mode: GameMode.Platformer, title: 'Platformer', description: 'The most popular platformer games of all time', color: 'var(--yellow-500)' },
    { mode: GameMode.RPG, title: 'RPG', description: 'The most popular RPG games of all time', color: 'var(--indigo-500)' },
    { mode: GameMode.Racing, title: 'Racing', description: 'The most popular racing games of all time', color: 'var(--blue-500)' },
    { mode: GameMode.Shooter, title: 'Shooter', description: 'The most popular shooters of all time', color: 'var(--teal-500)' },
    { mode: GameMode.Sport, title: 'Sport', description: 'The most popular sport games of all time', color: 'var(--orange-500)' },
    { mode: GameMode.Strategy, title: 'Strategy', description: 'The most popular strategy games of all time', color: 'var(--purple-500)' },
  ],
  theme: [
    { mode: GameMode.Drama, title: 'Drama', description: 'Popular games about people and feelings', color: 'var(--indigo-400)' },
    { mode: GameMode.Fantasy, title: 'Fantasy', description: 'Popular games about dragons and stuff', color: 'var(--cyan-400)' },
    { mode: GameMode.Horror, title: 'Horror', description: 'The scariest games of all time', color: 'var(--bluegray-900)' },
    { mode: GameMode.Romance, title: 'Romance', description: 'The top games about LUUUUUV', color: 'var(--pink-800)' },
  ],
  brand: [
    { mode: GameMode.PlayStation, title: 'PlayStation', description: 'Popular games published on PlayStation consoles', color: 'var(--indigo-400)' },
    { mode: GameMode.Nintendo, title: 'Nintendo', description: 'Popular games published on Nintendo consoles', color: 'var(--purple-400)' },
    { mode: GameMode.XBOX, title: 'XBOX', description: 'Popular games published on XBOX consoles', color: 'var(--green-400)' },
    { mode: GameMode.Sega, title: 'Sega', description: 'Popular games published on Sega consoles', color: 'var(--red-400)' },
  ],
});
const loading = ref(false);
const gamesRef = ref();
const games = ref<Game[]>([]);

const selectMode = (mode: GameModeOption | null) => {
  gamesRef.value?.();
  gameModel.value = {
    ...gameModel.value,
    mode,
  };
  games.value = [];
  window.scrollTo({ top: 0 });
  if (!mode) {
    return;
  }
  gamesRef.value = onSnapshot(query(collection(db, 'games'), where('settings.public', '==', true), where('mode', '==', mode.mode), where('status', '!=', 'ended'), orderBy('created_at', 'desc'), limit(50)), (snap) => {
    games.value = snap.docs.map((game) => game.data() as Game);
    console.log(games.value);
  });
};

const updateUser = async () => {
  if (loading.value) {
    return;
  }
  loading.value = true;
  try {
    const user = await client.post('/me', { name: userModel.value.name });
    gameModel.value = {
      name: `${user.name}'s game`,
      mode: null,
      type: null,
      rounds: 20,
      duration: 30,
      attempts: 0,
      public: true,
    };
    store.commit('setUser', user);
  } catch (error) {
    console.warn('UPDATE_USER_ERROR', error);
  }
  loading.value = false;
};

const createGame = async () => {
  if (loading.value) {
    return;
  }
  loading.value = true;
  try {
    const { name, rounds, mode, duration, attempts, public: isPublic, type } = gameModel.value;
    const game = await client.post('/games', {
      name,
      rounds,
      type,
      mode: mode.mode,
      duration,
      attempts,
      public: isPublic,
    });
    router.push(`/games/${game.id}`);
  } catch (error) {
    console.warn('CREATE_GAME_ERROR', error);
  }
  loading.value = false;
};

onBeforeUnmount(() => {
  gamesRef.value?.();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!gameModel.value.mode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameModes.value.popular, (mode) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "game-mode",
                  key: mode.mode,
                  onClick: ($event: any) => (selectMode(mode)),
                  style: _normalizeStyle({ backgroundColor: mode.color })
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(mode.title), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(mode.description), 1)
                  ])
                ], 12, _hoisted_8))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameModes.value.release, (mode) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "game-mode",
                  key: mode.mode,
                  onClick: ($event: any) => (selectMode(mode)),
                  style: _normalizeStyle({ backgroundColor: mode.color })
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(mode.title), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(mode.description), 1)
                  ])
                ], 12, _hoisted_15))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameModes.value.genre, (mode) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "game-mode",
                  key: mode.mode,
                  onClick: ($event: any) => (selectMode(mode)),
                  style: _normalizeStyle({ backgroundColor: mode.color })
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(mode.title), 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(mode.description), 1)
                  ])
                ], 12, _hoisted_22))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameModes.value.theme, (mode) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "game-mode",
                  key: mode.mode,
                  onClick: ($event: any) => (selectMode(mode)),
                  style: _normalizeStyle({ backgroundColor: mode.color })
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(mode.title), 1),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(mode.description), 1)
                  ])
                ], 12, _hoisted_29))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameModes.value.brand, (mode) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "game-mode",
                  key: mode.mode,
                  onClick: ($event: any) => (selectMode(mode)),
                  style: _normalizeStyle({ backgroundColor: mode.color })
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, _toDisplayString(mode.title), 1),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(mode.description), 1)
                  ])
                ], 12, _hoisted_36))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("h2", null, "Browse Games: " + _toDisplayString(gameModel.value.mode.mode), 1),
            _createElementVNode("div", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(games.value, (game) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  to: `/games/${game.id}`,
                  class: "game",
                  key: game.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_43, _toDisplayString(game.name), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createTextVNode(" " + _toDisplayString(Object.keys(game.players).length) + " / 8 ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createTextVNode(" " + _toDisplayString(game.status === _unref(GameStatus).Lobby ? 0 : game.current_round + 1) + " / " + _toDisplayString(game.settings.max_rounds), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ]),
          (!_unref(store).state.user?.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("form", {
                  onSubmit: _withModifiers(updateUser, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userModel.value.name) = $event)),
                      id: "name",
                      class: "input",
                      type: "text",
                      placeholder: "Enter a username...",
                      minlength: "1",
                      maxlength: "20",
                      disabled: loading.value,
                      required: ""
                    }, null, 8, _hoisted_53), [
                      [_vModelText, userModel.value.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("button", {
                      class: "btn",
                      disabled: loading.value || !userModel.value.name
                    }, "Create Game", 8, _hoisted_55)
                  ])
                ], 32)
              ]))
            : (!gameModel.value.type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("a", {
                    class: "game-mode",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (gameModel.value.type = _unref(GameType).Multi))
                  }, _hoisted_59),
                  _createElementVNode("a", {
                    class: "game-mode",
                    style: {"background-color":"var(--red-600)"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (gameModel.value.type = _unref(GameType).Challenge))
                  }, _hoisted_61)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _hoisted_63,
                  (gameModel.value.type === _unref(GameType).Multi)
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 0,
                        onSubmit: _withModifiers(createGame, ["prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((gameModel.value.name) = $event)),
                            id: "name",
                            class: "input",
                            type: "text",
                            placeholder: "Name of the game",
                            minlength: "1",
                            maxlength: "50",
                            disabled: loading.value,
                            required: ""
                          }, null, 8, _hoisted_66), [
                            [_vModelText, gameModel.value.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, [
                            _createTextVNode(" Mode "),
                            _createElementVNode("button", {
                              class: "btn small",
                              type: "button",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (selectMode(null)))
                            }, "Change")
                          ]),
                          _createElementVNode("div", {
                            class: "game-mode",
                            style: _normalizeStyle({ background: gameModel.value.mode.color })
                          }, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, _toDisplayString(gameModel.value.mode.title), 1),
                              _createElementVNode("div", _hoisted_71, _toDisplayString(gameModel.value.mode.description), 1)
                            ])
                          ], 4)
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("div", _hoisted_74, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((gameModel.value.rounds) = $event)),
                              id: "rounds",
                              type: "range",
                              min: "10",
                              max: "100",
                              step: "10",
                              disabled: loading.value,
                              required: ""
                            }, null, 8, _hoisted_75), [
                              [_vModelText, gameModel.value.rounds]
                            ]),
                            _createElementVNode("b", null, _toDisplayString(gameModel.value.rounds) + " rounds", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("div", _hoisted_78, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((gameModel.value.duration) = $event)),
                              id: "duration",
                              type: "range",
                              min: "15",
                              max: "60",
                              step: "15",
                              disabled: loading.value,
                              required: ""
                            }, null, 8, _hoisted_79), [
                              [_vModelText, gameModel.value.duration]
                            ]),
                            _createElementVNode("b", null, _toDisplayString(gameModel.value.duration) + " seconds", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _hoisted_81,
                          _createElementVNode("div", _hoisted_82, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((gameModel.value.attempts) = $event)),
                              id: "attempts",
                              type: "range",
                              min: "0",
                              max: "10",
                              step: "1",
                              disabled: loading.value,
                              required: ""
                            }, null, 8, _hoisted_83), [
                              [_vModelText, gameModel.value.attempts]
                            ]),
                            _createElementVNode("b", null, _toDisplayString(gameModel.value.attempts || 'Unlimited') + " attempts", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _createVNode(ToggleButton, {
                            id: "public",
                            modelValue: gameModel.value.public,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((gameModel.value.public) = $event)),
                            disabled: loading.value
                          }, null, 8, ["modelValue", "disabled"]),
                          _hoisted_85
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn outlined",
                            disabled: loading.value,
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (gameModel.value.type = null))
                          }, "Back", 8, _hoisted_87),
                          _createElementVNode("button", {
                            class: "btn",
                            disabled: loading.value || !gameModel.value.name
                          }, "Create Game", 8, _hoisted_88)
                        ])
                      ], 32))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        onSubmit: _withModifiers(createGame, ["prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn outlined",
                            disabled: loading.value,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (gameModel.value.type = null))
                          }, "Back", 8, _hoisted_90),
                          _createElementVNode("button", {
                            class: "btn",
                            disabled: loading.value
                          }, "Create Game", 8, _hoisted_91)
                        ])
                      ], 32))
                ]))
        ]))
  ]))
}
}

})